import { CCol, CRow } from "@coreui/react";
import React, { useEffect, useState } from "react";
import CommonList from "../common/CommonList";
import { apiCallResponse } from "src/_apiConfig/apiCall";
import Auth from "../../auth";
import {
  CommonSearch,
  SCSelect,
  updateSearchStatus,
} from "../common/CommonSearch";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import TableDateFromat from "../common/Table/TableDateFromat";
import TableButtonAnchor from "../common/Table/TableButtonAnchor";
import {
  FilterContainsInsensitive,
  FilterEqual,
  FilterKeyWord,
} from "../common/FilterCondition";
import { useParams } from "react-router-dom";

const TransferLotRequestList = () => {
  const { authenticated } = Auth();
  const { type } = useParams();
  const [usersData, setUserData] = useState([]); // List data manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage;
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage;
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage

  const [textField, settextField] = useState("transferFromUser");
  const [order, setorder] = useState("asc");
  const [orderClick, setOrderClick] = useState(true);

  const SearchFilterModel = {
    collectionSeason:  new Date().getFullYear().toString(),
    tenderNo: "",
    companyName: "",
    emailAddress: "",
    lotNo: "",
    status: (type != null || type !== undefined) && type === "2" ? "0" : "",
    isReferToHo:
      (type != null || type !== undefined) && type === "1" ? "No" : "",
  };

  const [search, setSearch] = useState(SearchFilterModel);

  // useEffect(() => {
  //   orderClick ? setorder("asc") : setorder("desc");
  //   getTransferLotList(true);
  //   getTenderCollectionSeasonDrop();
  //   getTenderDetails();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageLimit, textField, orderClick, itemPerPage, authenticated]);
  useEffect(() => {
    setloading(true);
    reset();
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getTransferLotList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getTransferLotList(true);
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    reset();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  let scopedSlotsList = {
    TransferStatus: (item, index) => {
      return (
        <td className="py-2">
          <span>
            {item.status === 0
              ? "Pending"
              : item.status === 1
              ? "Approved"
              : "Rejected"}
          </span>
        </td>
      );
    },
    TransferHOStatus: (item, index) => {
      return (
        <td className="py-2">
          <span>
            {item.hoStatus === null || item.hoStatus === undefined
              ? "Pending"
              : item.hoStatus === 1
              ? "Approved"
              : "Rejected"}
          </span>
        </td>
      );
    },
    requestDateTime: (item, index) => {
      return TableDateFromat(item.requestUpdateDateTime);
    },
    requestUpdateDateTime: (item, index) => {
      return TableDateFromat(item.requestUpdateDateTime);
    },
    viewTransferLetter: (item, index) => {
      return (
        <TableButtonAnchor
          fileName={item.transferLetterPath}
          path={item.transferLetterPath}
          buttonName={"View"}
        />
      );
    },
  };
  const fields = [
    {
      key: "transferFromUser",
      _style: { width: "15%" },
      label: TableHeaderSet("Transferor", "transferFromUser"),
    },
    {
      key: "transferToUser",
      label: TableHeaderSet("Transferee", "transferToUser"),
    },
    {
      key: "tenderNo",
      label: TableHeaderSet("Tender number", "tenderNo"),
    },
    {
      key: "lotNo",
      label: TableHeaderSet("Lot number", "lotNo"),
    },
    {
      key: "quantity",
      label: TableHeaderSet("Quantity", "quantity"),
    },
    {
      key: "purchaseRate",
      label: TableHeaderSet("Purchase Rate", "purchaseRate"),
    },
    {
      key: "purchasePrice",
      label: TableHeaderSet("Purchase Price", "purchasePrice"),
    },
    {
      key: "requestDateTime",
      label: TableHeaderSet("Request Date", "requestDateTime"),
    },
    {
      key: "requestUpdateDateTime",
      label: TableHeaderSet("Request Update Date", "requestUpdateDateTime"),
    },
    {
      key: "TransferStatus",
      label: TableHeaderSet("Status", "status"),
    },

    {
      key: "TransferHOStatus",
      label: "Ho Status",
    },

    {
      key: "isRefertoHo",
      label: "Refer To Ho",
    },
    {
      key: "show_details",
      label: "View",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "viewTransferLetter",
      label: "View Transfer Letter",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "collectionSeason",
      label: "Collection Season",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
      _classes: "d-none",
    },
  ];

  function reset() {
    setpageLimit(0);
  }
  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };

  //Pagging Disabled /Enable manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };

  // pagging Manage
  const paggingDisabledManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };
  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";

    filter = "&$filter=";

    if (authenticated.role === "DFO") {
      filter += "districtId eq " + authenticated.district;
      // +
      // " and isUserApproved eq true and payment ne null";
    }
    if (authenticated.role === "CFO") {
      filter += "circleId eq " + authenticated.district;
      // +
      // " and isUserApproved eq true and payment ne null";
    }

    if (search.companyName !== "" && search.companyName !== undefined) {
      if (filter !== "&$filter=") {
        filter += " and ";
      }
      filter +=
        "(contains(tolower(transferFromUser),'" +
        search.companyName +
        "') or contains(toupper(transferFromUser),'" +
        search.companyName +
        "')) or (contains(tolower(transferToUser),'" +
        search.companyName +
        "') or contains(toupper(transferToUser),'" +
        search.companyName +
        "'))";
    }

    filter = FilterContainsInsensitive(filter, "lotNo", search.lotNo);
    filter = FilterEqual(filter, "collectionSeason", search.collectionSeason);
    filter = FilterEqual(filter, "tenderNo", search.tenderNo);
    filter = FilterKeyWord(filter, "status", search.status, "eq");
    filter = FilterEqual(filter, "isRefertoHo", search.isReferToHo);

    if (filter === "&$filter=") {
      filter = "";
    }
    return filter;
  };
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(`LotTransfer?${filterManage()}`).then((res) => {
        if (res.success) paggingDisabledManage(parseInt(res.data.length) || 0);
      });
    }
  };
  const getTransferLotList = async (firstRequest, isFilter = true) => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `LotTransfer?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filterManage()}`
      ).then((res) => {
        if (res.success) {
          setUserData(res.data);
          if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingDisabledManage(pageCount);
          }
        }
        setloading(false);
      });
    }
    // setloading(true);
    // if (authenticated) {
    //   const header = new Headers();
    //   // header.append("", "");

    //   const response = await apiCall(
    //     `LotTransfer?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
    //       itemPerPage
    //     )}${filterManage}`,
    //     "GET",
    //     header,
    //     null
    //   );

    //   const jsonobj = await response.json();
    //   if (response.status === 200) {
    //     setUserData(jsonobj);
    //     console.log(jsonobj);
    //   }

    //   const responseCount = await apiCall(
    //     `LotTransfer?${filter}`,
    //     "GET",
    //     header,
    //     null
    //   );

    //   const jsonobjcount = await responseCount.json();

    //   if (responseCount.status === 200) {
    //   }

    //   setloading(false);
    //   pageLimit >= jsonobjcount.length - Number(itemPerPage)
    //     ? setdisablednext(true)
    //     : setdisablednext(false);

    //   pageLimit === 0 ? setdisabledprev(true) : setdisabledprev(false);
    // } else {
    //   setloading(false);
    // }
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
    paggingDisabledManage(pageCount);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };

  const statusList = [
    { value: "0", label: "Pending" },
    { value: "1", label: "Approved" },
    { value: "2", label: "Rejected" },
  ];
  const isReferToHoList = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];

  const SearchExtraControl = (
    <>
      <SCSelect
        labelname="Refer To Ho"
        name="isReferToHo"
        value={search.isReferToHo}
        onChange={updateSearch}
        items={isReferToHoList}
      />
      <SCSelect
        labelname="Status"
        name="status"
        value={search.status}
        onChange={updateSearch}
        items={statusList}
      />
    </>
  );

  let additional = (
    <>
      {/* <div>
        <CRow>
          <CCol xl={3}>
            <CLabel>Collection Season:</CLabel>

            <CSelect
              required
              aria-label="Default select example"
              id="collectionSeason"
              name="collectionSeason"
              value={search.collectionSeason}
              // eslint-disable-next-line no-use-before-define
              onChange={handleChangeTenderCollectionSeason}
            >
              <option value="">Select Collection Season</option>
              {itemsCollectionSeason.map((item, key) => (
                <option key={key} value={item.collectionSeason}>
                  {item.collectionSeason}
                </option>
              ))}
            </CSelect>
          </CCol>
          <CCol xl={3}>
            <CLabel>Select Tender number : </CLabel>
            <CSelect
              required
              aria-label="Default select example"
              id="tenderNo"
              name="tenderNo"
              value={search.tenderNo}
              onChange={updateSearch}
            >
              <option value="">Select Tender number</option>
              {items.map((item, key) => (
                <option key={key} value={item.tenderNo}>
                  {item.tenderNo}
                </option>
              ))}
            </CSelect>
          </CCol>

          {/* <CCol xl={3}>
            <CLabel>Company Name:</CLabel>
            <CInput
              id="companyName"
              name="companyName"
              value={search.companyName}
              onChange={updateSearch}
            />
          </CCol>* /}
          <CCol xl={3}>
            <CLabel>Email Address:</CLabel>
            <CInput
              id="emailAddress"
              name="emailAddress"
              value={search.emailAddress}
              onChange={updateSearch}
            />
          </CCol>
          <CCol xl={3}>
            <CLabel>Lot number: </CLabel>{" "}
            <CInput
              id="lotNo"
              name="lotNo"
              value={search.lotNo}
              onChange={updateSearch}
            />
          </CCol>
        </CRow>

        <div className="float-right col-md-auto mt-3 mb-3 ">
          <CLabel>Item Per Page</CLabel>
          <CSelect
            aria-label="Default select example"
            onChange={(e) => {
              reset();
              setItermPerPage(e.target.value);
            }}
          >
            <Options />
          </CSelect>
        </div>
        <CButton
          className="mt-5"
          color="success"
          onClick={() => {
            reset();
            getTransferLotList();
          }}
        >
          Search
        </CButton>
        <CButton
          className="ml-3 mr-3 mt-5 "
          color="danger"
          onClick={clearSearch}
        >
          Clear
        </CButton>
      </div> */}

      <CommonSearch
        isDisabledSearchClear={loading}
        isClear={isClear}
        search={search}
        updateSearch={updateSearch}
        searchButton={searchButton}
        clearSearch={clearSearch}
        itemPerPage={itemPerPage}
        onChangePage={onChangePage}
        isCompanyNameDisplay={true}
        CompanyNameLabel={"Transferor/Transferee Name : "}
        //isEmailAddressDisplay={true}
        isLotNumberDisplay={true}
        extraControl={SearchExtraControl}
      />
    </>
  );

  function clearSearch(ev) {
    ev.preventDefault();
    reset();

    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUserData();
  }

  return (
    <CRow>
      <CCol xl={12}>
        <CommonList
          items={usersData}
          fields={fields}
          listName="Lot Transfer Approval"
          loading={loading}
          additional={additional}
          prev={() => setpageLimit(pageLimit - Number(itemPerPage))}
          next={() => setpageLimit(pageLimit + Number(itemPerPage))}
          disabledprev={disabledprev}
          disablednext={disablednext}
          tabBtn="View"
          path="/transferlotapprovalview/"
          id="lotTransferId"
          scopedSlots={scopedSlotsList}
        />
      </CCol>
    </CRow>
  );
};

export default TransferLotRequestList;
